import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IUserDetails } from 'types';

import { isSmallScreen } from 'utils';
import { AppManagementState } from './types';

export const initialState: AppManagementState = {
  currentLocale: 'en',
  pageTitle: '',
  topBarMenu: [],
  mode: 'light',
  loading: false,
  error: '',
  userData: {} as IUserDetails,
  showStatusMessage: false,
  statusMessage: { type: 'success', message: '' },
  isMenuOpen: !isSmallScreen()
};

const localeSlice = createSlice({
  name: 'appManagement',
  initialState,
  reducers: {
    setCurrentLocale: (state, action: PayloadAction<string>) => {
      state.currentLocale = action.payload;
    },
    setThemeMode: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.mode = action.payload;
    },
    setMenuDrawerOpen: (state, action: PayloadAction<boolean>) => {
      state.isMenuOpen = action.payload;
    },
    fetchUser: state => {
      state.loading = true;
      state.error = '';
    },
    fetchUserSuccess: (state, action) => {
      state.loading = false;
      state.userData = action.payload;
    },
    fetchUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    showStatusMessage: (state, action) => {
      state.showStatusMessage = Boolean(action.payload);
      state.statusMessage = action.payload;
    },
    closeStatusMessage: state => {
      state.showStatusMessage = false;
      state.statusMessage = initialState.statusMessage;
    },
    logout: state => {
      state.loading = true;
    },
    logoutSuccess: () => {
      return initialState;
    },
    setPageTitle: (state, action) => {
      state.pageTitle = action.payload;
    },
    setTopBarMenu: (state, action) => {
      state.topBarMenu = action.payload;
    },
    updateMarkerterData: (state, action) => {
      state.loading = false;
      state.userData.marketer = action.payload;
    },
    updateProfileData: (state, action) => {
      state.loading = false;
      state.userData.profile = action.payload;
    }
  }
});

export const {
  setCurrentLocale,
  setThemeMode,
  fetchUser,
  fetchUserSuccess,
  fetchUserFailure,
  showStatusMessage,
  closeStatusMessage,
  logout,
  logoutSuccess,
  setMenuDrawerOpen,
  setPageTitle,
  setTopBarMenu,
  updateMarkerterData,
  updateProfileData
} = localeSlice.actions;

export default localeSlice.reducer;
